import axios from "./axiosConfig";
import jwt_decode from "jwt-decode";
import Cookies from 'js-cookie';
const basePath = process.env.NODE_ENV === "production" ? "/api/" : "";

const register = async (
  name,
  email,
  username,
  mobile,
  // password,
  // confirmPassword,
  partnerName,
  partnerEmail,
  registration,
  partnerMobile
) => {
  var Full_Name = name;
  var User_Name = username;
  var User_Mobile = mobile;
  var Agent_Name = partnerName;
  var Agent_Email = partnerEmail;
  var Agent_Mobile = partnerMobile;
  var Agent_Type = 4;
  var Channel_Type = "1";
  var Email = email;
  // var Password = password;
  // var ConfirmPassword = confirmPassword;
  var ValidateRegisterInput = await axios.post(
    "/Account/validate-register-input",
    {
      username: User_Name,
      email: Email,
    },
    {baseURL: basePath}
  );
  if(ValidateRegisterInput.data.Succeeded){
    var OnlineUser = await axios.post(
      "/v1/OnlineEtiqa/register",
      {
        Full_Name,
        User_Name,
        Email,
        User_Mobile,
        // Password,
        // ConfirmPassword,
        Agent_Name,
        Agent_Type,
        Channel_Type,
        Agent_Email,
        Agent_Mobile,
      },
      { baseURL: basePath }
    );
    if (OnlineUser.data.Status === 0) {
      var agentId = OnlineUser.data.Content;
      var User = await axios.post(
        "/Account/register",
        {
          name,
          username,
          email,
          mobile,
          // password,
          // confirmPassword,
        },
        { baseURL: basePath }
      );
      if (User.data.Succeeded) {
        var userId = User.data.Data;
        axios.post(
          "/v1/Partner",
          {
            userId,
            agentId,
            partnerName,
            partnerEmail,
            registration,
            partnerMobile,
          },
          { baseURL: basePath }
        );
      }
      return User.data;
    } else {
      var result = {
        Succeeded: false,
        Message: OnlineUser.data.Error,
        Error: null,
      };
      return result;
    }
  }
};

const login = (email, password, code) => {
  return axios
    .post(
      "/Account/authenticate",
      {
        email,
        password,
        OTP: code,
        UserAgent: window.navigator.userAgent,
        IsMobile: window.navigator.userAgentData.mobile,
        Platform: window.navigator.userAgentData.platform
      },
      { baseURL: basePath }
    )
    .then((response) => {
      var data = response.data.Data;
      if (data.JWToken) {
        Cookies.set('JWToken', data.JWToken, { secure: true, sameSite: 'strict' });
        localStorage.setItem("LastLoginTime", data.LastLoginTime);
        localStorage.setItem("ConcurrencyLoginStamp", data.ConcurrencyLoginStamp);
      }
      return response.data;
    });
};

const logout = () => {
  
  const token = Cookies.get("JWToken");
  var user = jwt_decode(token).uid;
  axios.get(
    "/Account/Userlogout?userId=" + user,
    { baseURL: basePath }
  );
  Cookies.remove('JWToken');
  localStorage.removeItem("LastLoginTime");
  localStorage.removeItem("reset");
  localStorage.removeItem("ConcurrencyLoginStamp");
};

const changePassword = (
  currentPassword,
  newPassword,
  confirmPassword
) => {
  const token = Cookies.get("JWToken");
  var decoded = jwt_decode(token);
  var UserId = decoded.uid;
  return axios.post(
    "/Account/change-password",
    {
      UserId,
      currentPassword,
      newPassword,
      confirmPassword,
    },
    { baseURL: basePath }
  );
};

const addContact = (
  email,
  companyName,
  clientName,
  phoneNo,
  purpose,
  apiCategories,
  registrationNumber,
  recaptchaToken
) => {
  return axios.post(
    "/v1/Contact",
    {
      email,
      companyName,
      clientName,
      phoneNo,
      purpose,
      apiCategories,
      registrationNumber,
      recaptchaToken
    },
    {baseURL:basePath}
  );
};

const forgetPassword = (email) => {
  return axios.post(
    "/Account/forgot-password",
    {
      email,
    },
    { baseURL: basePath }
  );
};

const resetPassword = (email, token, password, confirmPassword) => {
  return axios.post(
    "/Account/reset-password",
    {
      email,
      token,
      password,
      confirmPassword,
    },
    { baseURL: basePath }
  );
};

const refreshToken = (userId) => {
  return axios
    .post(
      "/Account/refresh-token",
      {
        userId,
      },
      { baseURL: basePath }
    )
    .then((response) => {
      var data = response.data.Data;
      if (data.JWToken) {
        Cookies.set('JWToken', data.JWToken, { secure: true, sameSite: 'strict' });
      }
      return response.data;
    });
};

const validateConcurrentLogin = (userId, concurrencyLoginStamp) => {
  return axios
    .post(
      "/Account/validate-concurrent-login",
      {
        id: userId,
        concurrencyLoginStamp: concurrencyLoginStamp
      },
      { baseURL: basePath }
    )
    .then((response) => {
      return response.data;
    });
};

export default {
  register,
  login,
  logout,
  changePassword,
  forgetPassword,
  resetPassword,
  refreshToken,
  validateConcurrentLogin,
  addContact
};
